export const watch = {
  hoaId() {
    this.reload()
  }
}
